import { ACTIONS_TYPES } from "../utils/constants";

export const initialState = {
  userDetails: null,

  registerUserErrors: null,
  registerUserLoader: false,
  registerUserSuccess: false,
};

export default function registerUserReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS_TYPES.REGISTER_USER_REQUEST:
      return { ...state, registerUserLoader: true, registerUserErrors: null, registerUserSuccess: false };

    case ACTIONS_TYPES.REGISTER_USER_SUCCESS:
      return { ...state, userDetails: action.payload, registerUserLoader: false, registerUserSuccess: true };

    case ACTIONS_TYPES.REGISTER_USER_FAILED:
      return { ...state, registerUserLoader: false, registerUserErrors: action.payload };

    case ACTIONS_TYPES.REGISTER_USER_RESET:
      return { initialState }
    

    default:
      return state;
  }
}